import React from 'react';

const PlaceholderComponent = ({ title, text, icon }) => {
	return (
		<div className="d-flex justify-content-center align-items-center" style={{ minHeight: "65vh" }}>
			<div className="text-center text-muted">
				{icon && (
					<div className="mb-3" style={{ color: "#20468c" }}>
						{icon}
					</div>
				)}
				{title && <h4 style={{ color: "#20468c" }}>{title}</h4>}
				{text && <p>{text}</p>}
			</div>
		</div>
	)
}

export default PlaceholderComponent;
